import { Avatar, Chip, Button, Menu, MenuItem, Box, Pagination } from "@mui/material";
import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { confirmOrder, deleteOrder, deliveredOrder, getOrders, shipOrder } from "../../../Redux/Admin/Orders/Action";
import { getOrderHistory } from "../../../Redux/Customers/Order/Action";
import OrderCard from "./Ordercard";
const TEXT_CLASS = "text-muted-foreground ";


const Orders = () => {
  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt");
  const  order = useSelector((store) => store.order.orders);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(""); // To track the selected status for filtering

  useEffect(() => {
    dispatch(getOrderHistory({ jwt }));
  }, [jwt, dispatch]);

  useEffect(() => {
    console.log(order)
    if (order) {
      // Filter based on selected status
      let updatedOrders = order;
      if (selectedStatus) {
        updatedOrders = updatedOrders.filter((order) => order.orderStatus === selectedStatus);
      }
      setFilteredOrders(updatedOrders);
    }
  }, [order, selectedStatus]);

  const handleStatusFilter = (status) => {
    setSelectedStatus(status);
  };

  return (
    <div className="p-4">
      <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0 mb-4">
        <div className="flex flex-wrap justify-center space-x-2">
          <button
            className="bg-secondary text-secondary-foreground px-4 py-2 rounded-lg hover:bg-secondary-dark hover:text-white"
            onClick={() => handleStatusFilter("")} 
          >
            All
          </button>
          <button
            className="bg-orange-500 text-white px-4 py-2 rounded-lg hover:bg-orange-600"
            onClick={() => handleStatusFilter("CONFIRMED")}
          >
           Confirmed
          </button>
          <button
            className="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600"
            onClick={() => handleStatusFilter("DELIVERED")}
          >
            Delivered
          </button>
          <button
            className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600"
            onClick={() => handleStatusFilter("PENDING")}
          >
           Pending
          </button>
        </div>
      </div>

      {filteredOrders.map((order) => (
        <OrderCard
          key={order._id}
          status={order.orderStatus}
          date={new Date(order.createdAt).toLocaleDateString()}
          imageSrc={order.orderItems|| "https://placehold.co/50x50"}
          orderID={order._id}
          items={order.orderItems.map((item) => item.product?.title).join(", ")}
          price={order.totalPrice}
        />
      ))}

      <Box sx={{ my: 1, display: "flex", justifyContent: "center" }}>
        <Pagination count={10} page={1} color="primary" />
      </Box>
    </div>
  );
};

export default Orders;
